import { type ButtonHTMLAttributes, forwardRef } from 'react';
import {
  buttonVariants,
  type ButtonAppearance,
  type ButtonColorTone,
  type ButtonStyleProps,
} from './button-variants';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  ButtonStyleProps & {
    isLoading?: boolean;
  };

export type { ButtonAppearance, ButtonColorTone };

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function Button(
    {
      className,
      variant = 'primary',
      size = 'md',
      fullWidth = false,
      colorTone,
      appearance = 'filled',
      isLoading = false,
      disabled,
      type = 'button',
      children,
      ...props
    },
    ref,
  ) {
    const isDisabled = disabled || isLoading;

    return (
      <button
        ref={ref}
        type={type}
        disabled={isDisabled}
        aria-busy={isLoading || undefined}
        data-loading={isLoading ? true : undefined}
        className={buttonVariants({
          variant,
          size,
          fullWidth,
          colorTone,
          appearance,
          className,
        })}
        {...props}
      >
        {isLoading ? (
          <span
            className='size-4 animate-spin rounded-full border-2 border-current border-t-transparent'
            aria-hidden
          />
        ) : null}
        {children}
      </button>
    );
  },
);
